import React from "react";
import Assessment from "../Assessment/Assessment";
import { ASSESSMENT_TYPES } from "../Assessment/assessmentType";

/**
 * Exam panel embedded in the Course Board / Subject Evaluation views.
 * Delegates to the shared Assessment shell rather than duplicating it.
 */
function AssignmentExam({
  subjectId = null,
  classId = null,
  canCreate = false,
  onCallback = console.log,
}) {
  return (
    <Assessment
      type={ASSESSMENT_TYPES.exam}
      subjectId={subjectId}
      classId={classId}
      canCreate={canCreate}
      onCallback={onCallback}
    />
  );
}

export default AssignmentExam;
